import Vue from 'vue'
import Router from 'vue-router'
import { firebase } from '@/firebase'
import { getCurrentUser, permissions, matchesPermission } from '@/helpers'

import Homepage from '@/components/Homepage'
import Projects from '@/components/Projects'
import Courses from '@/components/Courses'
import CourseDetail from '@/components/CourseDetail'
import CourseAdd from '@/components/CourseAdd'
import ProjectDetail from '@/components/ProjectDetail'
import Fiorino from '@/components/Fiorino'
import Mission from '@/components/Mission'
import ContactUs from '@/components/ContactUs'
import Blog from '@/components/Blog'
import UserProjects from '@/components/UserProjects'
import Error401 from '@/components/Error401'
import UserProjectDetail from '@/components/UserProjectDetail'
import Blockchain from '@/components/Blockchain'


// Admin Dashboard
import AdminDashboard from '@/components/AdminDashboard'
import AdminUserDashboard from '@/components/AdminUserDashboard'
import AdminProjectDashboard from '@/components/AdminProjectDashboard'
import AdminProjectAdd from '@/components/AdminProjectAdd'
import AdminProjectList from '@/components/AdminProjectList'


Vue.use(Router)

let router = new Router({
  mode: 'history',

  routes: [
    {
      path: '*',
      redirect: '/'
    },
    {
      path: '/error401',
      name: 'Error401',
      component: Error401
    },
    {
      path: '/',
      name: 'Homepage',
      component: Homepage
    },
    {
      path: '/projects',
      name: 'Projects',
      component: Projects
    },
    {
      path: '/courses',
      name: 'Courses',
      component: Courses
    },
    {
      path: '/course/detail/:id',
      name: 'CourseDetail',
      component: CourseDetail
    },
    {
      path: '/course/add',
      name: 'CourseAdd',
      component: CourseAdd,
      meta: {
        accessLevel: permissions.affiliate
      }
    },
    {
      path: '/project/:id',
      name: 'ProjectDetail',
      component: ProjectDetail
    },
    {
      path: '/fiorino',
      name: 'Fiorino',
      component: Fiorino
    },
    {
      path: '/blockchain',
      name: 'Blockchain',
      component: Blockchain
    },
    {
      path: '/mission',
      name: 'Mission',
      component: Mission
    },
    {
      path: '/contact_us',
      name: 'ContactUs',
      component: ContactUs
    },
    {
      path: '/blog',
      name: 'Blog',
      component: Blog
    },
    {
      path: '/user/projects',
      name: 'UserProjects',
      component: UserProjects,
      meta: {
        accessLevel: permissions.inventor
      }
    },
    {
      path: '/user/project/:id',
      name: 'UserProjectDetail',
      component: UserProjectDetail,
      meta: {
        accessLevel: permissions.inventor
      }
    },
    {
      path: '/admin',
      name: 'Dashboard',
      component: AdminDashboard,
      meta: {
        accessLevel: permissions.admin
      },
      children: [
        {
          path: 'project',
          name: 'AdminProjectDashboard',
          component: AdminProjectDashboard,
          meta: {
            accessLevel: permissions.admin
          },
          children: [
            {
              path: 'add',
              name: 'AdminProjectAdd',
              component: AdminProjectAdd,
              meta: {
                accessLevel: permissions.admin
              },
            },
            {
              path: 'list',
              name: 'AdminProjectList',
              component: AdminProjectList,
              meta: {
                accessLevel: permissions.admin
              }
            }
          ]
        },
        {
          path: 'user',
          name: 'AdminUserDashboard',
          component: AdminUserDashboard,
          meta: {
            accessLevel: permissions.admin
          }
        },
      ]
    },
  ],
  scrollBehavior(to, from, savedPosition) {
    return savedPosition ? savedPosition : { x: 0, y: 0 }
  }
})

router.beforeEach((to, from, next) => {
  let toAccessLevel
  to.matched.some(route => {
    toAccessLevel = route.meta.accessLevel
  })

  let currentFirebaseUser = firebase.auth().currentUser

  if (toAccessLevel != undefined) {
    if (currentFirebaseUser) {
      getCurrentUser(currentFirebaseUser.email)
        .then(user => {
          if (user.accessLevel <= toAccessLevel)
            next()
          else
            next('error401')
        })
    } else {
      next('error401')
    }
  } else {
    next()
  }
})

export default router


// WEBPACK FOOTER //
// ./src/router/index.js